export default "__VITE_ASSET__aPxB9j_Y__"